import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import i18next from 'i18next';
import * as usersApi from './../../api/users-api';
import * as blockUtils from './../../utils/BlockUtils';
import * as viewUtils from './../../utils/view-utils';
import EditAction from './../utils/actions/EditAction';
import TableActions from './../utils/TableActions';
import PopoverBtn from './../utils/PopoverBtn';
import SitesTableList from '../developers/SitesTableList';
import ReduxDataTable, {onRowClick} from '../redux_data_table/ReduxDataTable';
import * as rights from '../../model/rights';
import RegisterNewUserForm from './RegisterNewUserForm';
import EditAnotherUserForm from './EditAnotherUserForm';
import TableAction from '../utils/actions/TableAction';
import {UserLanguages} from '../../model/user';
import PermissionsForm from './permissions/PermissionsForm';
import SiteAccessForm from './site_access/SiteAccessForm';
import DestroyAction from '../utils/actions/DestroyAction';

class UsersList extends Component {
  constructor(props) {
    super(props);

    this.userFormDialogId = 'userFormDialog';
    this.permissionsFormDialogId = 'permissionsFormDialogId';
    this.siteAccessFormDialogId = 'siteAccessFormDialogId';

    this.showUserForm = this.showUserForm.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
  }

  deleteUser(user) {
    blockUtils.blockUI(`#${this.tableId}`);
    usersApi.deleteUser(user).then(() => {
      blockUtils.unblockUI('#users_table');
      this.props.getData();
    }).catch((err) => {
      this.handleError(err);
      blockUtils.unblockUI('#users_table');
    });
  }

  componentDidMount() {
    usersApi.getAvailableSiteForUser().then((response) => {
      this.setState({sites: response.data});
    }).catch((error) => {
      window.showAlert(i18next.t('error'), error);
    });
  }

  componentDidUpdate() {
    this.handleError();
  }

  handleError() {
    if (this.props.createUserError) {
      if (this.modalDialog) {
        this.modalDialog.handleError(this.props.createUserError);
      }
      blockUtils.unblockUI();
    } else {
      $(`#${this.userFormDialogId}`).modal('hide');
    }
  }

  showUserForm(user) {
    const props = {
      dialogId: this.userFormDialogId,
      error: this.props.createUserError,
      presentedUser: user,
      availableRoles: this.props.availableRoles,
      sites: this.state.sites,
    };
    this.modalDialog = viewUtils.showModal(user ? EditAnotherUserForm : RegisterNewUserForm, this.userFormDialogId, props);
  }

  showSiteAccessForm(user) {
    const props = {
      dialogId: this.siteAccessFormDialogId,
      user: user,
      onCloseClick: this.props.getData,
    };
    this.modalDialog = viewUtils.showModal(SiteAccessForm, this.siteAccessFormDialogId, props);
  }

  showPermissionsForm(user) {
    const props = {
      dialogId: this.permissionsFormDialogId,
      user: user,
    };
    this.modalDialog = viewUtils.showModal(PermissionsForm, this.permissionsFormDialogId, props);
  }

  filterListAndReturnSitesSelectedByUser(user) {
    return user.sites.filter((site) => site.selectedByUser === true);
  }

  render() {
    return (
      <div className="table-container">
        <ReduxDataTable
          {...this.props}
          notSortable={[6, 7]}
          showCreateButton={true}
          createRecordCallback={this.showUserForm}
        >
          <thead>
            <tr role="row" className="odd heading">
              <th>ID</th>
              <th>{i18next.t('users.attrs.login')}</th>
              <th>{i18next.t('users.attrs.email')}</th>
              <th>{i18next.t('users.attrs.role')}</th>
              <th>{i18next.t('users.attrs.language')}</th>
              <th>{i18next.t('users.attrs.site_name')}</th>
              <th>{i18next.t('actions')}</th>
            </tr>
          </thead>
          <tbody>
            {this.props.users.map((user) => {
              return (
                <tr onClick={() => onRowClick(user.id)} key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.username ? user.username : user.email}</td>
                  <td>{user.email}</td>
                  <td>{i18next.t([`users.roles.${user.role}`])}</td>
                  <td>{UserLanguages[user.language]}</td>
                  <td>
                    {(user.sites && user.sites.length) > 0 ?
                      (<PopoverBtn viewClass='btn btn-xs'
                        popoverContent={ReactDOMServer.renderToStaticMarkup(<SitesTableList sites={this.filterListAndReturnSitesSelectedByUser(user)}/>)}
                        title={`${i18next.t('sites.name', {count: 2})}: ${this.filterListAndReturnSitesSelectedByUser(user).length}`}/>) :
                      <button className="btn btn-xs popover_btn">
                        {`${i18next.t('sites.name', {count: 2})}: 0`}
                      </button>}
                  </td>
                  <td>
                    <TableActions identifier={user.id}>
                      <EditAction
                        onEdit={() => this.showUserForm(user)}
                        condition={user.enabled && rights.currentUserHasRight(rights.USER_EDIT_PRIVILEGE)}
                      />
                      <TableAction
                        text={i18next.t('users.permissions.list_option')}
                        action={() => this.showPermissionsForm(user)}
                        condition={user.enabled && !rights.isCurrentUser(user.id) && rights.currentUserHasRight(rights.PERMISSIONS_READ_PRIVILEGE)}
                        icon="icon-wrench"
                      />
                      <TableAction
                        text={i18next.t('sites.site_management.user_site_menu')}
                        action={() => this.showSiteAccessForm(user)}
                        condition={user.enabled && !rights.isCurrentUser(user.id) && rights.currentUserHasRight(rights.USER_EDIT_PRIVILEGE)}
                        icon="icon-wrench"
                      />
                      <DestroyAction
                        destroyElement={() => this.deleteUser(user)}
                        condition={rights.currentUserHasRight(rights.USER_DISABLE_PRIVILEGE)}
                      />
                    </TableActions>
                  </td>
                </tr>);
            })}
          </tbody>
        </ReduxDataTable>
      </div>
    );
  }
}

UsersList.propTypes = {
  users: PropTypes.array,
  createUserError: PropTypes.any,
  availableRoles: PropTypes.array,
  sites: PropTypes.array,
  getData: PropTypes.func,
};
UsersList.defaultProps = {};

export default UsersList;
